module.exports = __webpack_public_path__ + "img/product.3b8e18d6.svg";